module.exports = __webpack_public_path__ + "img/zhuanzhu.2a2bf005.png";